import React from 'react';
import { useSubscription } from '../../hooks/useSubscription';
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Clock, CreditCard } from "lucide-react";
import { LoadingSpinner } from "@/components/ui/loading-spinner";

export function SubscriptionStatus() {
  const {
    status,
    cancel,
    resume,
    isCancelling,
    isResuming,
  } = useSubscription();

  if (!status) {
    return (
      <Card>
        <CardHeader>
          <CardTitle>Subscription Status</CardTitle>
        </CardHeader>
        <CardContent>
          <div className="flex items-center justify-center h-24">
            <LoadingSpinner size="lg" variant="default" />
          </div>
        </CardContent>
      </Card>
    );
  }

  return (
    <Card>
      <CardHeader className="pb-3">
        <CardTitle>Subscription Status</CardTitle>
      </CardHeader>
      <CardContent>
        <div className="space-y-4">
          <div className="flex items-center justify-between">
            <div>
              <span className="font-semibold">Current Plan:</span>{' '}
              <span className="font-medium text-sauna-navy">{status.current_plan.name}</span>
            </div>
            {status.current_plan.id !== 'free' && (
              <span className={`px-2 py-1 text-sm rounded-full ${
                status.current_plan.id === 'premium' 
                  ? 'bg-sauna-orange/10 text-sauna-orange' 
                  : 'bg-sauna-blue/10 text-sauna-blue'
              }`}>
                Active
              </span>
            )}
          </div>

          {status.is_on_trial && (
            <div className="bg-sauna-orange/10 p-3 rounded-lg text-sm flex items-center gap-2 text-sauna-orange">
              <Clock size={16} />
              <span>Trial ends in {status.trial_days_remaining} days</span>
            </div>
          )}

          <div className="pt-2">
            <span className="font-semibold">Feature Limits:</span>
            <ul className="mt-2 space-y-2">
              <li className="flex justify-between">
                <span>Service Listings:</span>
                <span className="font-medium">
                  {status.feature_limits.service_listings === null
                    ? 'Unlimited'
                    : status.feature_limits.service_listings}
                </span>
              </li>
              <li className="flex justify-between">
                <span>Gallery Images:</span>
                <span className="font-medium">
                  {status.feature_limits.gallery_images === null
                    ? 'Unlimited'
                    : status.feature_limits.gallery_images}
                </span>
              </li>
            </ul>
          </div>

          <div className="pt-4 flex flex-col sm:flex-row gap-3">
            {status.current_plan.id !== 'free' && !status.is_on_trial && (
              <Button 
                variant="destructive" 
                onClick={() => cancel()} 
                disabled={isCancelling}
                className="w-full sm:w-auto"
              >
                {isCancelling ? (
                  <>
                    <LoadingSpinner size="sm" variant="default" className="mr-2" />
                    Cancelling...
                  </>
                ) : 'Cancel Subscription'}
              </Button>
            )}
            
            {status.current_plan.id === 'free' && (
              <Button 
                onClick={() => window.location.href = '/pricing'} 
                className="w-full sm:w-auto bg-sauna-orange hover:bg-sauna-orange/90"
              >
                <CreditCard className="mr-2 h-4 w-4" /> Upgrade Plan
              </Button>
            )}
          </div>
        </div>
      </CardContent>
    </Card>
  );
}
